import api from "./api";
const base = "/specstudio";
const data = (promise) => promise.then((r) => r.data.data);
const specstudioService = {
  getPrinters: () => data(api.get(`${base}/printers`)),
  getCategories: () => data(api.get(`${base}/categories`)),
  getProducts: (params) => data(api.get(`${base}/products`, { params })),
  createProduct: (d) => data(api.post(`${base}/products`, d)),
  getProductById: (id) => data(api.get(`${base}/products/${id}`)),
  updateProduct: (id, d) => data(api.put(`${base}/products/${id}`, d)),
  deleteProduct: (id) => data(api.delete(`${base}/products/${id}`)),
  duplicateProduct: (id) => data(api.post(`${base}/products/${id}/duplicate`)),
  createProvider: (id, d) =>
    data(api.post(`${base}/products/${id}/providers`, d)),
  updateProvider: (id, d) => data(api.put(`${base}/providers/${id}`, d)),
  deleteProvider: (id) => data(api.delete(`${base}/providers/${id}`)),
  duplicateProvider: (id, d) =>
    data(api.post(`${base}/providers/${id}/duplicate`, d)),
  createSpec: (id, d) => data(api.post(`${base}/providers/${id}/specs`, d)),
  updateSpec: (id, d) => data(api.put(`${base}/specs/${id}`, d)),
  deleteSpec: (id) => data(api.delete(`${base}/specs/${id}`)),
  generateSku: (d) => data(api.post(`${base}/generate-sku`, d)),
};
export default specstudioService;
